import React, { useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/discountsSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import ViewSelector from "./smartComponents/ViewSelector";
import BreakdownView from "./smartComponents/BreakdownView";
import TrendView from "./smartComponents/TrendView";
import "./discounts.scss";

const DiscountsModule = (props) => {
  const dispatch = useDispatch();

  const initialRequest = useSelector((state) => state.discounts.initialRequest);
  const isLoading = useSelector((state) => state.discounts.isLoading);
  const moduleView = useSelector((state) => state.discounts.selectedFilters.moduleView);

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = moduleView.id === "breakdown" ? <BreakdownView /> : <TrendView />;

  return (
    <div id="module-date-filters">
      <div id="discounts">
        <SectionToggle
          height={690}
          title="Discounts"
          isLoading={isLoading}
          content={content}
          learnMore={<ViewSelector />}
        />
      </div>
    </div>
  );
};

export default memo(DiscountsModule);
